const servicesData = [
  {
    id: 1,
    title: "Wedding Photography",
    description: "Complete wedding coverage with candid and traditional shots",
    features: ["Full day coverage", "2 photographers", "Candid & traditional", "Edited photos"]
  },
  {
    id: 2,
    title: "Pre-Wedding Shoot",
    description: "Romantic pre-wedding photoshoot at your favorite location",
    features: ["Location selection", "Outfit changes", "HD quality photos", "Photo album"]
  },
  {
    id: 3,
    title: "Event Coverage",
    description: "Professional coverage for all your special events",
    features: ["Event photography", "Video coverage", "Quick delivery", "Online gallery"]
  },
  {
    id: 4,
    title: "Portrait Photography",
    description: "Professional portraits for individuals and families",
    features: ["Studio setup", "Multiple poses", "Retouched images", "Print options"]
  }
];

export default servicesData;
